import { ReactourStep } from 'reactour';
import { ImageVariant, TWidgetType } from '../../Media/types/media.types';
import { TBasicLogAction } from '../../../types/log.types';
import { ICompanyUser } from './companyUser.types';

export enum ECustomerPlan {
  'INTERNAL' = 'INTERNAL',
  'PAYING' = 'PAYING',
  'FREEMIUM' = 'FREEMIUM',
  'TRIAL' = 'TRIAL',
  'INACTIVE' = 'INACTIVE',
}

export enum ECompanyStatus {
  INVITED = 'INVITED',
  NOT_INVITED = 'NOT_INVITED',
  REGISTERED = 'REGISTERED',
}

export enum ECompanyFeature {
  FEEDBACK = 'FEEDBACK',
  CERTIFICATES = 'CERTIFICATES',
  WHITE_LABELING = 'WHITE_LABELING',
  VERIFIED_PAYMENTS = 'VERIFIED_PAYMENTS',
}

export enum EFarmDisplayOption {
  FARM_ID = 'FARM_ID',
  FARM_NAME = 'FARM_NAME',
  FARM_OWNER_NAME = 'FARM_OWNER_NAME',
}

export enum ESiteDisplayOption {
  SITE_ID = 'SITE_ID',
  SITE_NAME = 'SITE_NAME',
}

export type TSiteDisplayOption = `${ESiteDisplayOption}`;

export type TFarmDisplayOption = `${EFarmDisplayOption}`;

export type TCustomerPlanType = `${ECustomerPlan}`;

export type TCompanyStatusType = `${ECompanyStatus}`;

export type TCompanyFeatureType = `${ECompanyFeature}`;

export interface ICompanyLog {
  id: string;
  comment: string;
  userEmail: string;
  user: ICompanyUser;
  company: IBaseCompany;
  timestamp: Date;
  action: TBasicLogAction;
}

export interface ICompanyPlan {
  name: string;
  expired: boolean;
  upgradeRequested: boolean;
  expirationDate?: string | null;
  daysLeftInTrial: number;
  customerPlanId: string;
  planType: TCustomerPlanType;
  features: TCompanyFeatureType[];
}

/**
 * This base type needs to match exactly the fields of the @IBasePartnerCompany
 */
export interface IBaseCompany {
  id: string;
  name: string;
  logo?: ImageVariant;
  modifiedTimestamp: Date;
  createdTimestamp: Date;
  status: TCompanyStatusType;
  externalId?: string;
  countriesOfBusiness: string[];
}

export interface ICompany extends IBaseCompany {
  sitesCount: number;
  activitiesCount: number;
  description?: string;
  website: string;
  onlineShop?: string;
  address?: IAddress;
  planDetails?: ICompanyPlan;
  design?: ICompanyDesign;
  integrationSettings?: IntegrationSettings;
  dataValid: boolean;
  apiKey: string;
  gaTrackingId: string;
  social: ISocialSettings;
  vatNumber?: string;
  eoriNumber?: string;
  mapboxApiToken?: string;
  useDefaultMapboxKey?: boolean;
  farmDisplayOption: EFarmDisplayOption;
  siteDisplayOption: ESiteDisplayOption;
}

export interface IntegrationSettings {
  showClaims: boolean;
  widgetType: TWidgetType;
}

export interface IAddress {
  street: string;
  streetNumber: string;
  zipCode: string;
  city: string;
  country: string;
}
export interface ICompanyDesign {
  typography: ICompanyTypography;
  palette: ICompanyPalette;
}

export interface ICompanyTypography {
  header: string;
  body: string;
}

export interface ICompanyPalette {
  primary: string;
  secondary: string;
}

export interface ISocialSettings {
  twitter: string | null;
  facebook: string | null;
  instagram: string | null;
}

export interface IOnboardingTour {
  tourSteps: ReactourStep[];
  amplitudeEvent: string;
  onCompleted: () => null | void;
  firstStepButtonText: string;
}
